import './registrationCtrl';
import './loginCtrl';
import './officeCtrl';
import './pageCtrl';
import './offerCtrl';
import './report/reportCtrl';



// WEBPACK FOOTER //
// src/js/controllers/partner/index.js